<div class="tire-add-new-dialog">
  <div class="tire-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-tire font-20 font-gray-45 header-icon font-white"></i>
        <div class="pl-1 tire-description width-100p p-relative">
          <p class="m-0 font-secondary-700 font-14 font-white" *ngIf="!tireId">Add new tire</p>
          <p class="m-0 font-secondary-700 font-14 font-white" *ngIf="tireId">
            <!-- {{ tire?.brand?.name }} - {{ tire?.model }} -->
            Tire Storage Details
          </p>
        </div>
        <i class="print-tire-storage-btn pointer font-21" tooltipPosition="top" *ngIf="openFrom === 'tire-storage-list'" 
          [disabled]="isPrintingLabel" 
          tooltipStyleClass="font-11" 
          [pTooltip]="'Print tire storage sticker'" 
          [ngClass]="{'fal fa-spinner rotate': isPrintingLabel, 'far fa-print' : !isPrintingLabel }" 
          (click)="handleTirestoragePrint()">
        </i>
        <i id="tire-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>

  <!-- Tire storage body -->
  <div [ngClass]="{ 'disabled-storage-modal': isReadOnly}" [hidden]="isLoading" class="tire-storage-body-wrapper">
    <div class="tire-storage-body-inner">
      <div class="tire-storage-field-row">
        <div class="with-icon flex-between-center">
          <div class="tire-storage-icon-box">
            <!-- <div class="tire-storage-icon-wrapper">
              <img src="../../../../assets/img/tire-storage-img-1.svg" alt="">
            </div> -->
            <div class="tire-storage-icon-text">Tire Details</div>
          </div>

          <div class="tire-storage-far-right flex-start-center gap-10px" [ngClass]="{ 'disabled-storage-modal': isReadOnly }">
            <button class="btn btn-use-past flex-start-center gap-10px mt-1" *ngIf="!isReadOnly && lastTireStorage?._id && lastTireStorage?.tiresInfo && lastTireStorage?.tiresInfo.length"
              [disabled]="!(lastTireStorage?._id && lastTireStorage?.tiresInfo && lastTireStorage?.tiresInfo.length)" 
              (click)="populateLastTireStorageData()"
              tooltipPosition="top"
              [escape]="false"
              id="use-past-storage-details"
              [pTooltip]="!(lastTireStorage?._id && lastTireStorage?.tiresInfo && lastTireStorage?.tiresInfo.length) ? 'No previous tire returns' : usePastStorageTooltip">
              <!-- <i class="fal fa-clipboard-list font-18"></i> -->
              <span class="font-600">{{usePastStorageBtnText}}</span>
            </button>
            <app-checkbox [isChecked]="isAllTiresSame" label="All tires are the same" (appChange)="onSelectTire(isAllTiresSame)"> </app-checkbox>
          </div>
        </div>

        <!-- All tire same -->
        <div class="all-tires-same" *ngIf="isAllTiresSame">
          <!-- Fields -->
          <div class="tire-storage-field-box mt-4">
            <div class="tire-storage-field half">
              <label for="Tire Size">Tire Size*</label>
              <div class="tire-storage-field-combination" [ngClass]="{ active: focus.width || focus.ratio || focus.rim, 'invalid': !tireSize?.width || !tireSize?.ratio || !tireSize?.rim }">
                <div class="tire-size-input left">
                  <app-input
                    id="group-name"
                    type="text"
                    placeholder="Width"
                    [value]="tireSize.width"
                    [allowDecimal]="true"
                    [autoFocus]="focus?.width"
                    (appChange)="handleSizeChange($event, 'width')"
                    (appBlur)="handleBlur('width')"
                    (appFocus)="handleFocus('width')"
                    [fontSize]="16"
                  ></app-input>
                </div>
                <div class="tire-size-input center">
                  <app-input
                    id="group-name"
                    type="text"
                    placeholder="Aspect ratio"
                    [value]="tireSize.ratio"
                    [allowDecimal]="true"
                    [autoFocus]="focus?.ratio"
                    (appChange)="handleSizeChange($event, 'ratio')"
                    (appBlur)="handleBlur('ratio')"
                    (appFocus)="handleFocus('ratio')"
                    [fontSize]="16"
                  ></app-input>
                </div>
                <div class="tire-size-input right">
                  <app-input
                    id="group-name"
                    type="text"
                    placeholder="Rim diameter"
                    [value]="tireSize.rim"
                    [allowDecimal]="true"
                    [autoFocus]="focus?.rim"
                    (appChange)="handleSizeChange($event, 'rim')"
                    (appBlur)="handleBlur('rim')"
                    [fontSize]="16"
                  ></app-input>
                </div>
              </div>

              <div *ngIf="focus.width || focus.ratio || focus.rim && isTireConnectConnected" class="tire-size-wrapper" style="width:670px">
                <ng-container *ngIf="!loadingSizes">
                  <div *ngIf="vehicleRecommendedSizes.length" class="recommended-sizes-label font-12 font-500">RECOMMENDED SIZES</div>
                  <div class="chips-wrapper d-flex" *ngIf="vehicleRecommendedSizes.length">
                    <div *ngFor="let recSizes of vehicleRecommendedSizes" id="recommended-size-office-app" class="chip pointer mr-2" (click)="selectTireSize(recSizes, true)">{{ recSizes?.label }}</div>
                  </div>
                  <div class="recommended-sizes-label font-12 font-500">{{ vehicleSizeSectionName }}</div>
                  <ul class="p-0">
                    <li *ngFor="let itemSize of allVehicleSizes" class="item-size p-2 flex-start-center" (click)="selectTireSize(itemSize)">
                      <div class="service-item-details search-item flex-between-center">
                        <div class="flex-start-center s-item-content-sec">
                          <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                            <span class="flex-start-center font-secondary-700 text-truncate font-14" style="width: 160px">
                              <span class="text-truncate">{{ itemSize }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </ng-container>
                <div class="tire-loader" *ngIf="loadingSizes">
                  <span class="loading-tire">
                    Loading
                    <i class="fal fa-spinner rotate"></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="tire-storage-field half-2">
              <label for="Tire Size">Wheel Type*</label>
              <app-dropdown
                id="group-markup"
                listId="group-markup-list"
                field="name"
                scrollHeight="180px"
                tabindex="0"
                placeholder="Select wheel type"
                styleClassValue="text-truncate"
                itemWidth="394px"
                theme="border"
                [isDropdownIconVisible]="true"
                [fontSize]="16"
                [hasError]="!tire?.rimType?.name"
                [value]="tire?.rimType"
                [options]="rimTypes"
                [listItemFontSize]="14"
                (appSave)="handleRimTypeSave($event)"
                (appSelect)="handleChange($event, 'rimType')"
              ></app-dropdown>
            </div>
          </div>

          <div class="tire-storage-field-box mt-4">
            <div class="tire-storage-field half brand-wrapper">
              <label for="Tire Size">Tire Brand*</label>
              <app-auto-complete
                *ngIf="!isTireConnectConnected"
                placeholder="Select brand"
                scrollHeight="198px"
                editFieldLabel="Create brand"
                tooltipPosition="top"
                editableItemIdKey="_id"
                editFieldPlaceholder="Create brand"
                [autoFocus]="!tireId"
                [fontSize]="16"
                [theme]="errors?.brand ? 'border' : 'border'"
                [value]="tire?.brand?.name"
                [isInvalid]="!tire?.brand?.name"
                [listItemFontSize]="14"
                [isSaveForFuture]="true"
                [hasFutureSelectionField]="false"
                [isDropdownIconVisible]="true"
                [suggestions]="tagsSuggestion"
                tooltipStyleClass="tire-storage-tt"
                [hasEditableField]="!isNewItemCategoriesEnable ? true : false"
                (appCompletedMethod)="handleTagSearch($event)"
                (appClear)="handleClear('brand')"
                (appSelect)="handleSelect($event, 'brand')"
                (appSave)="handleCreateBrand($event)"
                (appUpdateItem)="onUpdateItem($event, 'brand')"
              >
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center">
                    <div>
                      <span>{{ item?.name }}</span>
                    </div>
                    <div class="tag-item-action flex-end-center" *ngIf="!isNewItemCategoriesEnable">
                      <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>

              <app-auto-complete
                *ngIf="isTireConnectConnected"
                placeholder="Select brand"
                scrollHeight="198px"
                editFieldLabel="Create brand"
                tooltipPosition="top"
                editableItemIdKey="_id"
                editFieldPlaceholder="Create brand"
                [autoFocus]="!tireId"
                [fontSize]="16"
                [theme]="errors?.brand ? 'border' : 'border'"
                [value]="tire?.brand?.name"
                [isInvalid]="!tire?.brand?.name"
                [listItemFontSize]="14"
                [isSaveForFuture]="true"
                [closeOnSelection]="true"
                [hasFutureSelectionField]="false"
                [isDropdownIconVisible]="true"
                [suggestions]="tagsSuggestion"
                tooltipStyleClass="tire-storage-tt"
                [hasEditableField]="false"
                [hasCustomListTemplate]="false"
                (appCompletedMethod)="handleTagSearch($event)"
                (appClear)="handleClear('brand')"
                (appSelect)="handleSelect($event, 'brand', null, close)"
                (appSave)="handleCreateBrand($event)"
                (appUpdateItem)="onUpdateItem($event, 'brand')"
              >

                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center">
                    <div>
                      <span>{{ item?.name }}</span>
                    </div>
                  </div>
                </ng-template>

                <!-- <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close" appTemplate="list">
                  <li class="source-suggestions-local">
                    <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                      <li
                        class="font-12 font-black p-2 source-suggestion-label"
                        *ngFor="let item of tireConnectBrands; let i = index"
                        id="item-{{ i }}"
                        (click)="handleSelect(item, 'brand', null, close)"
                      >
                        <span class="search-item d-flex">
                          <div class="ui-g p-0">
                            <div class="ui-g-12 p-0 flex-start-start">
                              <span class="font-13 font-500">
                                {{ item?.name }}
                              </span>
                            </div>
                          </div>
                        </span>
                      </li>
                    </ul>
                  </li>

                  <li class="source-suggestions-local">
                    <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                      <li
                        class="font-12 font-black p-2 source-suggestion-label"
                        *ngFor="let item of categories; let i = index"
                        id="item-{{ i }}"
                        (click)="handleSelect(item, 'brand', null, close)"
                      >
                        <span class="search-item d-flex">
                          <div class="ui-g p-0">
                            <div class="ui-g-12 p-0 flex-start-start">
                              <span class="font-13 font-500">
                                {{ item?.name }}
                              </span>
                            </div>
                          </div>
                        </span>
                      </li>
                    </ul>
                  </li>
                </ng-template> -->
              </app-auto-complete>
            </div>

            <div class="tire-storage-field half-2 tire-model-ddl">
              <label for="Tire Size">Tire Model*</label>
              <app-input
                placeholder="Enter model"
                [theme]="errors?.model ? 'border' : 'border'"
                [fontSize]="16"
                [isInvalid]="!tire?.model"
                [autoFocus]="focus.model"
                [value]="tire?.model"
                (appChange)="handleChange($event, 'model')"
                (appBlur)="handleBlur('model')"
                (appFocus)="handleFocus('model')"
              >
              </app-input>

              <div *ngIf="isTireConnectConnected && focus?.model && tireConnectModels?.length" class="tire-size-wrapper" >
                <ng-container *ngIf="!loadingModels">
                  <ul class="p-0">
                    <li *ngFor="let itemModel of tireConnectModels" id="tire-model-office-app" class="item-size flex-start-center" style="border-bottom: unset;" (click)="handleChange(itemModel.name, 'model')">
                      <div class="service-item-details search-item flex-between-center">
                        <div class="flex-start-center s-item-content-sec">
                          <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                            <span class="flex-start-center font-secondary-700 text-truncate font-14" style="width: 160px">
                              <span class="text-truncate">{{ itemModel.name }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </ng-container>
                <div class="tire-loader" *ngIf="loadingModels">
                  <span class="loading-tire">
                    Loading
                    <i class="fal fa-spinner rotate"></i>
                  </span>
                </div>
              </div>

              <!-- <app-dropdown
                *ngIf="isTireConnectConnected"
                id="model"
                field="name"
                listId="model-list"
                scrollHeight="180px"
                placeholder="Select from list"
                styleClassValue="text-truncate"
                itemWidth="394px"
                theme="border"
                [isDropdownIconVisible]="true"
                [fontSize]="16"
                [value]="tire?.model"
                [options]="tireConnectModels"
                [listItemFontSize]="14"
                (appSave)="handleRimTypeSave($event)"
                (appSelect)="handleChange($event, 'model')"
              ></app-dropdown> -->
            </div>
          </div>

          <!-- Seasonality -->
          <div class="tire-storage-field-box mt-4">
            <div class="tire-storage-field half" [ngClass]="{ 'disabled-storage-modal': isReadOnly }">
              <label for="Tire Size">Seasonality*</label>
              <div class="ui-g-12 p-0 seasonality-wrapper">
                <div
                  class="ui-g-6 p-1 seasonality-tab text-center pointer"
                  (click)="isReadOnly ? '' : handleChange('summer', 'seasonality')"
                  [ngClass]="{ active: tire?.seasonality === 'summer' }"
                >
                  <i class="far fa-sun font-gray-35"></i>
                  <span class="pl-6p">Summer</span>
                </div>

                <div
                  class="ui-g-6 p-1 seasonality-tab text-center pointer"
                  (click)="isReadOnly ? '' : handleChange('winter', 'seasonality')"
                  [ngClass]="{ active: tire?.seasonality === 'winter' }"
                >
                  <i class="far fa-cloud-snow font-gray-35"></i>
                  <span class="pl-6p">Winter</span>
                </div>
              </div>
            </div>

            <div class="tire-storage-field half-2">
              <label for="Tire Size">Tire Inspection*</label>
              <div class="tire-storage-field-box">
                <div class="tire-storage-field half-2 with-border flex-between-center border-radius-4px flex-basis-100">
                  <app-service-inspection [isArchived]="false" [inspection]="service?.inspection?.inspectionId"
                  [isLockedRO]="false" [isTireStorageInspection]="service?.inspection?.isTireStorageInspection"
                  [isFinalized]="isFinalizedRo" [companyLocalization]="companyLocalization" [currentLang]="currentLang"></app-service-inspection>
                  <div class="perform-btn pointer" [ngClass]="{'not-allowed': !item.associatedInspection}" (click)="handleOpenInspectionDialog()">
                    <span> View Inspection </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Else different tires -->
        <div class="all-tires-not-same mt-4" *ngIf="!isAllTiresSame">
          <ng-container *ngFor="let tireInfo of tire?.tiresInfo; let i = index">
            <div class="tire-storage-field-row dull-bg blue-bg" [ngClass]="{ 'mt-3': i !== 0, 'green-bg': tireInfo.isCompleted }">
              <!-- <div class="tire-placement-heading">{{ tireInfo?.tireLabel }}</div> -->
              <div class="filter-pill my-1 ml-0" [ngClass]="{ 'disabled-storage-modal': isReadOnly }">
                <app-content-overlay [dropshadow]="false" [showArrow]="false" [closeAfterAction]="true" right="unset" top="38px">
                  <ng-template appTemplate="item">
                    <div class="filter-pill-inner-wrapper d-flex" [ngClass]="{ 'disabled-estimate-field': false }">
                      <div class="filter-text w-115px text-overflow-ellipsis align-self-center pr-2">
                        <span class="font-600 font-14 secondary-500"> {{ tireInfo?.tireLabel }} </span>
                      </div>
                      <span class="align-self-center">
                        <i class="px-2 align-self-center fal fa-chevron-down secondary-500"></i>
                      </span>
                    </div>
                  </ng-template>

                  <ng-template appTemplate="overlay">
                    <div class="filter-overlay w-150">
                      <ng-container *ngFor="let position of tirePositionOptions; let i = index">
                        <div class="filter-option p-10p flex-between-center" (click)="selectTirePosition(position, tireInfo)">
                          <div class="text-truncate">
                            <span class="pt-1 pl-1">{{ position.name }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-template>
                </app-content-overlay>
              </div>
              <div class="tire-placement-with-image-wrapper">
                <div class="car-image-wrapper {{ tireInfo?.class }}">
                  <img src="../../../../assets/img/tire-storage-car-img-1.png" alt="" />
                </div>
                <div class="car-image-right-fields width-100p">
                  <div class="tire-storage-field-box">
                    <div class="tire-storage-field half" [ngClass]="{ 'magic-focus': tireInfo.isSizeDuplicated }">
                      <label for="Tire Size">Tire Size*</label>
                      <div class="tire-storage-field-combination" [ngClass]="{ active: tireInfo.focus?.width || tireInfo.focus?.ratio || tireInfo.focus?.rim, 'magic-focus': tireInfo.isSizeDuplicated, 'invalid': !tireInfo?.width || !tireInfo?.ratio || !tireInfo?.rim }">
                        <div class="tire-size-input left">
                          <app-input
                            id="group-name"
                            type="text"
                            placeholder="Width"
                            [value]="tireInfo.width"
                            [disabled]="isReadOnly"
                            [allowDecimal]="true"
                            [autoFocus]="tireInfo.focus?.width"
                            (appChange)="handleSizeChange($event, 'width', tireInfo, i)"
                            (appBlur)="handleBlur('width', tireInfo, i)"
                            (appFocus)="handleFocus('width', tireInfo)"
                            [fontSize]="16"
                          ></app-input>
                        </div>
                        <div class="tire-size-input center">
                          <app-input
                            id="group-name"
                            type="text"
                            placeholder="Aspect ratio"
                            [value]="tireInfo.ratio"
                            [disabled]="isReadOnly"
                            [allowDecimal]="true"
                            [autoFocus]="tireInfo.focus?.ratio"
                            (appChange)="handleSizeChange($event, 'ratio', tireInfo, i)"
                            (appBlur)="handleBlur('ratio', tireInfo, i)"
                            (appFocus)="handleFocus('ratio', tireInfo)"
                            [fontSize]="16"
                          ></app-input>
                        </div>
                        <div class="tire-size-input right">
                          <app-input
                            id="group-name"
                            type="text"
                            placeholder="Rim diameter"
                            [disabled]="isReadOnly"
                            [value]="tireInfo.rim"
                            [allowDecimal]="true"
                            [autoFocus]="tireInfo.focus?.rim"
                            (appChange)="handleSizeChange($event, 'rim', tireInfo, i)"
                            (appBlur)="handleBlur('rim', tireInfo, i)"
                            (appFocus)="handleFocus('rim', tireInfo)"
                            [fontSize]="16"
                          ></app-input>
                        </div>
                      </div>

                      <div *ngIf="tireInfo.focus?.width || tireInfo.focus?.ratio || tireInfo.focus?.rim && isTireConnectConnected" class="tire-size-wrapper" style="width: 592px">
                        <ng-container *ngIf="!tireInfo.loadingSizes">
                          <div *ngIf="vehicleRecommendedSizes.length" class="recommended-sizes-label font-12 font-500">RECOMMENDED SIZES</div>
                          <div class="chips-wrapper d-flex" *ngIf="vehicleRecommendedSizes.length">
                            <div *ngFor="let recSizes of vehicleRecommendedSizes" id="recommended-size-office-app" class="chip pointer mr-2" (click)="selectTireSize(recSizes, true, tireInfo, i)">{{ recSizes?.label }}</div>
                          </div>
                          <div class="recommended-sizes-label font-12 font-500">{{ vehicleSizeSectionName }}</div>
                          <ul class="p-0 mb-0">
                            <li *ngFor="let itemSize of allVehicleSizes" class="item-size p-2 flex-start-center" (click)="selectTireSize(itemSize, false, tireInfo, i)">
                              <div class="service-item-details search-item flex-between-center">
                                <div class="flex-start-center s-item-content-sec">
                                  <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                                    <span class="flex-start-center font-secondary-700 text-truncate font-14" style="width: 160px">
                                      <span class="text-truncate">{{ itemSize }}</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </ng-container>
                        <div class="tire-loader" *ngIf="tireInfo.loadingSizes">
                          <span class="loading-tire">
                            Loading
                            <i class="fal fa-spinner rotate"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="tire-storage-field half-2" [ngClass]="{ 'magic-focus': tireInfo.isRimTypeDuplicated, 'error-border': !tireInfo?.rimType }">
                      <label for="Tire Size">Wheel Type*</label>
                      <app-dropdown
                        id="wheel-type{{ i }}"
                        listId="wheel-type-list{{ i }}"
                        field="name"
                        scrollHeight="180px"
                        tabindex="0"
                        placeholder="Select wheel type"
                        styleClassValue="text-truncate"
                        itemWidth="394px"
                        theme="border"
                        [hasError]="!tireInfo?.rimType?.name"
                        [disabled]="isReadOnly"
                        [isDropdownIconVisible]="true"
                        [fontSize]="16"
                        [value]="tireInfo?.rimType"
                        [options]="rimTypes"
                        [listItemFontSize]="14"
                        (appSave)="handleRimTypeSave($event)"
                        (appSelect)="handleChange($event, 'rimType', i)"
                      ></app-dropdown>
                    </div>
                  </div>
                  <div class="tire-storage-field-box mt-4">
                    <div class="tire-storage-field half brand-wrapper" [ngClass]="{ 'magic-focus': tireInfo.isBrandDuplicated }">
                      <label for="Tire Size">Tire Brand*</label>
                      <app-auto-complete
                        *ngIf="!isTireConnectConnected"
                        placeholder="Select brand"
                        scrollHeight="198px"
                        editFieldLabel="Create brand"
                        tooltipPosition="top"
                        editableItemIdKey="_id"
                        editFieldPlaceholder="Create brand"
                        [autoFocus]="!tireId"
                        [fontSize]="16"
                        [theme]="errors?.brand ? 'border' : 'border'"
                        [value]="tireInfo?.brand?.name"
                        [isInvalid]="!tireInfo?.brand?.name"
                        [hasError]="errors?.brand"
                        [listItemFontSize]="14"
                        [isSaveForFuture]="true"
                        [hasFutureSelectionField]="false"
                        [isDropdownIconVisible]="true"
                        [suggestions]="tireInfo.tagsSuggestion || tagsSuggestion"
                        [disabled]="isReadOnly"
                        [hasEditableField]="!isNewItemCategoriesEnable ? true : false"
                        tooltipStyleClass="tire-storage-tt"
                        (appCompletedMethod)="handleTagSearch($event, tireInfo)"
                        (appClear)="handleClear('brand', tireInfo)"
                        (appSelect)="handleSelect($event, 'brand', i)"
                        (appSave)="handleCreateBrand($event)"
                        (appUpdateItem)="onUpdateItem($event, 'brand')"
                      >
                        <ng-template let-item let-editItem="editItem" appTemplate="item">
                          <div class="tag-item flex-between-center">
                            <div>
                              <span>{{ item?.name }}</span>
                            </div>
                            <div class="tag-item-action flex-end-center" *ngIf="!isNewItemCategoriesEnable">
                              <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                            </div>
                          </div>
                        </ng-template>
                      </app-auto-complete>

                      <app-auto-complete
                        *ngIf="isTireConnectConnected"
                        placeholder="Select brand"
                        scrollHeight="198px"
                        editFieldLabel="Create brand"
                        tooltipPosition="top"
                        editableItemIdKey="_id"
                        editFieldPlaceholder="Create brand"
                        [autoFocus]="!tireId"
                        [fontSize]="16"
                        [theme]="errors?.brand ? 'border' : 'border'"
                        [value]="tireInfo?.brand?.name"
                        [isInvalid]="!tireInfo?.brand?.name"
                        [hasError]="errors?.brand"
                        [listItemFontSize]="14"
                        [isSaveForFuture]="true"
                        [closeOnSelection]="true"
                        [hasFutureSelectionField]="false"
                        [isDropdownIconVisible]="true"
                        [suggestions]="tireInfo.tagsSuggestion || tagsSuggestion"
                        [disabled]="isReadOnly"
                        tooltipStyleClass="tire-storage-tt"
                        [hasEditableField]="false"
                        [hasCustomListTemplate]="false"
                        (appCompletedMethod)="handleTagSearch($event, tireInfo)"
                        (appClear)="handleClear('brand', tireInfo)"
                        (appSelect)="handleSelect($event, 'brand', i)"
                        (appSave)="handleCreateBrand($event)"
                        (appUpdateItem)="onUpdateItem($event, 'brand')"
                      >
                        <ng-template let-item let-editItem="editItem" appTemplate="item">
                          <div class="tag-item flex-between-center">
                            <div>
                              <span>{{ item?.name }}</span>
                            </div>
                            <!-- <div class="tag-item-action flex-end-center" *ngIf="!isNewItemCategoriesEnable">
                              <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                            </div> -->
                          </div>
                        </ng-template>
                        <!-- <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close" appTemplate="list">
                          <li class="source-suggestions-local">
                            <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                              <li
                                class="font-12 font-black p-2 source-suggestion-label"
                                *ngFor="let item of tireConnectBrands; let cb = index"
                                id="item-{{ cb }}"
                                (click)="handleSelect(item, 'brand', i, close)"
                              >
                                <span class="search-item d-flex">
                                  <div class="ui-g p-0">
                                    <div class="ui-g-12 p-0 flex-start-start">
                                      <span class="font-13 font-500">
                                        {{ item?.name }}
                                      </span>
                                    </div>
                                  </div>
                                </span>
                              </li>
                            </ul>
                          </li>

                          <li class="source-suggestions-local">
                            <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                              <li
                                class="font-12 font-black p-2 source-suggestion-label"
                                *ngFor="let item of tagsSuggestion; let ts = index"
                                id="item-{{ ts }}"
                                (click)="handleSelect(item, 'brand', i, close)"
                              >
                                <span class="search-item d-flex">
                                  <div class="ui-g p-0">
                                    <div class="ui-g-12 p-0 flex-start-start">
                                      <span class="font-13 font-500">
                                        {{ item?.name }}
                                      </span>
                                    </div>
                                  </div>
                                </span>
                              </li>
                            </ul>
                          </li>
                        </ng-template> -->
                      </app-auto-complete>
                    </div>

                    <div class="tire-storage-field half-2 tire-model-ddl" [ngClass]="{ 'magic-focus': tireInfo.isModelDuplicated }">
                      <label for="Tire Size">Tire Model*</label>
                      <app-input
                        placeholder="Enter model"
                        [disabled]="isReadOnly"
                        [theme]="errors?.model ? 'border' : 'border'"
                        [fontSize]="16"
                        [autoFocus]="tireInfo?.focus?.model"
                        [isInvalid]="!tireInfo?.model"
                        [value]="tireInfo?.model"
                        (appChange)="handleChange($event, 'model', i)"
                        (appBlur)="handleBlur('model', tireInfo, i)"
                        (appFocus)="handleFocus('model', tireInfo)"
                      >
                      </app-input>

                      <div *ngIf="isTireConnectConnected && tireInfo.focus?.model && tireInfo?.tireConnectModels?.length" class="tire-size-wrapper">
                        <ng-container *ngIf="!loadingModels">
                          <ul class="p-0">
                            <li *ngFor="let itemModel of tireInfo?.tireConnectModels" id="tire-model-office-app" class="item-size flex-start-center" style="border-bottom: unset;" (click)="handleChange(itemModel.name, 'model', i)">
                              <div class="service-item-details search-item flex-between-center">
                                <div class="flex-start-center s-item-content-sec">
                                  <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                                    <span class="flex-start-center font-secondary-700 text-truncate font-14" style="width: 160px">
                                      <span class="text-truncate">{{ itemModel.name }}</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </ng-container>
                        <div class="tire-loader" *ngIf="loadingModels">
                          <span class="loading-tire">
                            Loading
                            <i class="fal fa-spinner rotate"></i>
                          </span>
                        </div>
                      </div>

                      <!-- <app-dropdown
                        *ngIf="isTireConnectConnected"
                        id="model"
                        field="name"
                        listId="model-list"
                        scrollHeight="180px"
                        placeholder="Select from list"
                        styleClassValue="text-truncate"
                        itemWidth="394px"
                        theme="border"
                        [disabled]="isReadOnly || isOpenFromInventory"
                        [isDropdownIconVisible]="true"
                        [fontSize]="16"
                        [value]="tireInfo?.model"
                        [options]="tireConnectModels"
                        [listItemFontSize]="14"
                        (appSave)="handleRimTypeSave($event)"
                        (appSelect)="handleChange($event, 'model', i)"
                      ></app-dropdown> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- blue-bg orange-bg green-bg -->

          <!-- Inspection -->
          <div class="tire-storage-field-box mt-4">
            <div class="tire-storage-field half" [ngClass]="{ 'disabled-storage-modal': isReadOnly}">
              <label for="Tire Size">Seasonality*</label>
              <div class="ui-g-12 p-0 seasonality-wrapper">
                <div
                  class="ui-g-6 p-1 seasonality-tab text-center pointer"
                  (click)="isReadOnly ? '' : handleChange('summer', 'seasonality')"
                  [ngClass]="{ active: tire?.seasonality === 'summer' }"
                >
                  <i class="far fa-sun font-gray-35"></i>
                  <span class="pl-6p">Summer</span>
                </div>

                <div
                  class="ui-g-6 p-1 seasonality-tab text-center pointer"
                  (click)="isReadOnly ? '' : handleChange('winter', 'seasonality')"
                  [ngClass]="{ active: tire?.seasonality === 'winter' }"
                >
                  <i class="far fa-cloud-snow font-gray-35"></i>
                  <span class="pl-6p">Winter</span>
                </div>
              </div>
            </div>

            <div class="tire-storage-field half-2">
              <label for="Tire Size">Tire Inspection*</label>
              <div class="tire-storage-field-box">
                <div class="tire-storage-field half-2 with-border flex-between-center border-radius-4px flex-basis-100">
                  <app-service-inspection [isArchived]="false" [inspection]="service?.inspection?.inspectionId"
                  [isLockedRO]="false" [isTireStorageInspection]="service?.inspection?.isTireStorageInspection"
                  [isFinalized]="isFinalizedRo" [companyLocalization]="companyLocalization" [currentLang]="currentLang"></app-service-inspection>
                  <div class="perform-btn pointer" [ngClass]="{'not-allowed': !item.associatedInspection}" (click)="handleOpenInspectionDialog()">
                    <span> View Inspection </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Location -->
      <div class="tire-storage-field-row mt-3">
        <div class="with-icon flex-between-center">
          <div class="tire-storage-icon-box">
            <div class="tire-storage-icon-text">Location Details</div>
          </div>
        </div>
        <!-- Fields -->
        <div class="tire-storage-field-box mt-4">
          <div class="tire-storage-field half">
            <label for="Tire Size">Warehouse*</label>
            <!-- <app-dropdown id="group-markup" listId="group-markup-list" field="title" scrollHeight="180px" styleClass=""
              styleClassSelectedView="" styleClassValue="" styleClassDropdownList="" placeholder="Select warehouse"
              styleClassValue="text-truncate" itemWidth="394px" theme="border" [isDropdownIconVisible]="true"
              [fontSize]="16"></app-dropdown> -->
            <div class="width-100p pl-1 pr-2" class="complete-autocomplete-disabled">
              <app-auto-complete
                id="tire-storage-location"
                listId="tire-storage-location-list"
                label="Select warehouse"
                placeholder="Select warehouse"
                field="name"
                scrollHeight="180px"
                theme="border"
                editableItemIdKey="locationId"
                editFieldLabel="Create Warehouse"
                #warehouseDropdown
                [isInvalid]="!tire?.storageLocation?.name"
                [hasCustomEditableField]="true"
                [hasEditableField]="true"
                [hasFutureSelectionField]="false"
                [closeOnSelection]="true"
                [isDropdownIconVisible]="true"
                [hasStaticUnassignedFiled]="false"
                [suggestions]="locationResults"
                [listItemFontSize]="14"
                [fontSize]="14"
                [disabled]="isReadOnly"
                [value]="tire?.storageLocation?.name"
                [isSetPositionDynamically]="false"
                (appUpdateItem)="onStorageLocationUpdate($event)"
                (appSelect)="handleSelect($event, 'storageLocation')"
                (appSave)="onStorageLocationSave($event)"
                [isSaveForFuture]="true"
                (appCompletedMethod)="searchLocation($event)"
                (appClear)="onStorageLocationClear()"
              >
                <!-- tooltipPosition="top"
                    tooltipStyleClass="concern-tooltip"
                    [ngClass]="{ 'not-allowed': item.name }"
                    [pTooltip]="item.name ? 'No space available in this warehouse. Click the pen icon to adjust capacity or choose a different warehouse.' : ''" -->

                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div
                    class="tag-item flex-between-center"
                    tooltipPosition="top"
                    tooltipStyleClass="tire-storage-tt"
                    [pTooltip]="item.totalCapacity <= item.usedCapacity ? 'No space available in this warehouse. Click the pen icon to adjust capacity or choose a different warehouse.' : ''"
                  >
                    <div [ngClass]="{'disabled-storage-modal opacity-low': item.totalCapacity <= item.usedCapacity }">
                      <span>{{ item?.name }}</span>
                    </div>
                    <div class="tag-item-action flex-end-center">
                      <span
                        class="chips mr-2 font-12"
                        [ngClass]="{ 'success-bg': item.totalCapacity > item.usedCapacity, 'red-bg disabled-storage-modal opacity-low': item.totalCapacity <= item.usedCapacity }"
                        >{{ item.usedCapacity }}/{{ item.totalCapacity }}</span
                      >
                      <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); onEditItem(item, 'warehouse')"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template let-item appTemplate="editable">
                  <div [ngClass]="isCreateNew ? 'create-new' : ''">
                    <div *ngIf="!isCreateNew" class="font-600" (click)="$event.stopPropagation(); isCreate(true, 'warehouse')">Create Warehouse</div>
                    <div *ngIf="isCreateNew" class="row add-new-warehouse p-0 font-gray mt-1">
                      <div class="col-6 pr-1">
                        <label class="font-12 font-gray-700 font-600 mb-0" for="group-name">Name</label>
                        <app-input
                          placeholder="Enter warehouse name"
                          [isInvalid]="errors?.name"
                          styleClass="input-create-new-sale-code"
                          theme="border"
                          [fontSize]="12"
                          [value]="newWarehouse.name"
                          (appChange)="handleChangeWarehouse('name', $event)"
                          (appFocus)="onFocus('name')"
                        ></app-input>
                      </div>
                      <div class="col-6 pl-1">
                        <label class="font-12 font-gray-700 font-600 mb-0" for="group-name">Total Capacity</label>
                        <app-input
                          placeholder="Enter total capacity"
                          [allowDecimal]="true"
                          [isInvalid]="errors?.capacity"
                          styleClass="input-create-new-sale-code"
                          theme="border"
                          [fontSize]="12"
                          [value]="newWarehouse.capacity"
                          (appChange)="handleChangeWarehouse('capacity', $event)"
                          (appFocus)="onFocus('capacity')"
                        ></app-input>
                      </div>
                    </div>

                    <div *ngIf="isCreateNew" class="row flex-between-end my-2">
                      <div class="col-6 pr-1">&nbsp;</div>
                      <div class="col-6 pl-1">
                        <div class="d-flex justify-content-end">
                          <button [disabled]="loader.isSavingCode" id="warehouse-cancel-btn" class="btn btn-white pointer btn-submit ml-2" (click)="$event.stopPropagation(); isCreate(false)">
                            Cancel
                          </button>

                          <button
                            id="warehouse-save-btn"
                            class="btn btn-primary btn-submit pointer ml-2"
                            tooltipPosition="top"
                            tooltipStyleClass="tooltip-width-medium text-center"
                            (click)="onStorageLocationSave(newWarehouse)"
                          >
                            <span class="font-bold">{{ isEditModeCode ? 'Save' : 'Create' }}</span>
                            <i *ngIf="loader.isSavingCode" class="fal fa-spinner rotate ml-2"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>

          <div class="tire-storage-field half-2 bin-wrapper">
            <label for="Tire Size">Bin</label>
            <!-- <app-dropdown id="group-markup" listId="group-markup-list" field="title" scrollHeight="180px" styleClass=""
              styleClassSelectedView="" styleClassValue="" styleClassDropdownList="" placeholder="Select bin"
              styleClassValue="text-truncate" itemWidth="394px" theme="border" [isDropdownIconVisible]="true"
              [fontSize]="16"></app-dropdown> -->
            <div
              class="width-100p pl-1 pr-2"
              tooltipPosition="top"
              tooltipStyleClass="tire-storage-tt"
              [pTooltip]="!tire.storageLocation?.locationId ? 'Please select a warehouse to see or create related bins.' : ''"
            >
              <app-auto-complete
                id="tire-storage-bin"
                listId="tire-storage-bin-list"
                label="Select bin"
                placeholder="Select bin"
                field="name"
                scrollHeight="180px"
                theme="border"
                editableItemIdKey="binId"
                editFieldLabel="Create Bin"
                [hasEditableField]="true"
                [hasFutureSelectionField]="false"
                [closeOnSelection]="true"
                [isDropdownIconVisible]="true"
                [hasStaticUnassignedFiled]="false"
                [suggestions]="binResults"
                [listItemFontSize]="14"
                [fontSize]="14"
                [disabled]="!tire.storageLocation?.locationId || isReadOnly"
                [value]="tire?.storageBin?.name"
                [hasCustomEditableField]="true"
                [isSetPositionDynamically]="false"
                editFieldPlaceholder="Create brand"
                (appUpdateItem)="onStorageBinUpdate($event)"
                (appSelect)="handleSelect($event, 'storageBin')"
                (appSave)="onStorageBinSave($event)"
                [isSaveForFuture]="true"
                (appCompletedMethod)="searchBin($event)"
                (appClear)="onStorageBinClear()"
              >
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center">
                    <div>
                      <span>{{ item?.name }}</span>
                    </div>
                    <div class="tag-item-action flex-end-center">
                      <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); onEditItem(item, 'bin')"></i>
                    </div>
                  </div>
                </ng-template>

                <!-- Create field -->
                <ng-template let-item appTemplate="editable">
                  <div [ngClass]="isCreateNew ? 'create-new' : ''">
                    <div *ngIf="!isCreateNew" class="bin-create-btn font-600" (click)="$event.stopPropagation(); isCreate(true, 'bin')">Create Bin</div>
                    <div *ngIf="isCreateNew" class="row add-new-warehouse p-0 font-gray mt-1">
                      <div class="col-12">
                        <label class="font-12 font-gray-700 font-600 mb-0" for="group-name">Name</label>
                        <app-input
                          placeholder="Enter bin name"
                          [isInvalid]="errors?.name"
                          styleClass="input-create-new-sale-code"
                          theme="border"
                          [fontSize]="12"
                          [value]="newBin.name"
                          (appChange)="handleChangeBin('name', $event)"
                          (appFocus)="onFocus('name')"
                        ></app-input>
                      </div>
                    </div>

                    <div *ngIf="isCreateNew" class="row flex-between-end my-2">
                      <div class="col-6 pr-1">&nbsp;</div>
                      <div class="col-6 pl-1">
                        <div class="d-flex justify-content-end">
                          <button [disabled]="loader.isSavingCode" id="warehouse-cancel-btn" class="btn btn-white pointer btn-submit ml-2" (click)="$event.stopPropagation(); isCreate(false)">
                            Cancel
                          </button>

                          <button id="warehouse-save-btn" class="btn btn-primary btn-submit pointer ml-2" (click)="onStorageBinSave(bin)">
                            <span class="font-bold">{{ isEditModeCode ? 'Save' : 'Create' }}</span>
                            <i *ngIf="loader.isSavingCode" class="fal fa-spinner rotate ml-2"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>
        </div>
      </div>

      <!-- Internal Notes -->
      <!-- Location -->
      <div class="tire-storage-field-row mt-3 input-basic-info-wrapper">
        <div class="with-icon flex-between-center mb-3">
          <div class="tire-storage-icon-box">
            <!-- <div class="tire-storage-icon-wrapper">
              <img src="../../../../assets/img/tire-storage-img-2.svg" alt="">
            </div> -->
            <div class="tire-storage-icon-text">Internal Notes (Optional)</div>
          </div>
        </div>

        <app-textarea
          textAreaId="Notes"
          theme="border"
          placeholder="Add notes here"
          [maxLength]="10000"
          [floatingLabel]="false"
          [disabled]="isReadOnly"
          [autoGrow]="true"
          [maxAutoGrowHeight]="64"
          [fontSize]="14"
          [rows]="1"
          [value]="tire.internalNotes"
          (appChange)="handleChange($event, 'internalNotes')"
        >
        </app-textarea>
      </div>
    </div>
  </div>

  <div class="tire-storage-loading" *ngIf="isLoading">
    <span class="loading-tire">
      Loading
      <i class="fal fa-spinner rotate"></i>
    </span>
  </div>

  <div class="ui-g-12 text-right dialog-footer">
    <button id="btn-cancel" class="btn btn-border pointer btn-submit mr-2 ng-star-inserted" (click)="handleCloseModal()">{{isReadOnly ? 'Close' : 'Cancel'}}</button
    ><button id="btn-save" class="btn btn-primary btn-submit ng-star-inserted" *ngIf="!isReadOnly" (click)="handleSubmit()" [disabled]="isLoading"><span>Save</span></button>
  </div>
</div>
